module.exports = __webpack_public_path__ + "static/media/hanukiah.5f3cdc8f.svg";